import { all, fork, take, takeLatest } from "redux-saga/effects";
import { REHYDRATE } from "redux-persist/lib/constants";

import authSagas from "./auth/saga";
import requestSagas from "./request/saga";
import bookingSagas from "./booking/saga";
import alacarteSagas from "./alacarte/saga";
import iotSagas from "./iot/saga";
import serviceSagas from "./service/saga";
import settingsSagas, { getHotelSettingsSaga } from "./settings/saga";

import { HOTEL_SETTINGS_GET, HOTEL_SETTINGS_SUCCESS } from "./actions";

export default function* rootSaga() {
  yield take(REHYDRATE); // Wait for rehydrate to prevent sagas from running with empty store
  yield takeLatest(HOTEL_SETTINGS_GET, getHotelSettingsSaga);
  yield take(HOTEL_SETTINGS_SUCCESS);

  yield all([
    fork(settingsSagas),
    fork(authSagas),
    fork(iotSagas),
    fork(requestSagas),
    fork(bookingSagas),
    fork(alacarteSagas),
    fork(serviceSagas),
  ]);
}
